<template>
  <transition
    name="fade"
    mode="out-in"
    @beforeLeave="beforeLeave"
    @enter="enter"
    @afterEnter="afterEnter"
  >
    <section
      :id="id"
      ref="provider-statement-non-auth"
      class="provider-statement-non-auth"
      v-show="isShown"
    >
      <div class="provider-statement-non-auth_form">
        <h2
          v-if="selectedProvider.isHSF"
          class="provider-statement-non-auth_form_title"
          tabindex="-1"
          ref="sectionTitle"
        >
          Now, let's enroll in HSF<span class="sup">&reg;</span> with your provider.
        </h2>
        <h2
          v-else-if="selectedProvider.isCommerceCare"
          class="provider-statement-non-auth_form_title"
          tabindex="-1"
          ref="sectionTitle"
        >
          Now, let's apply for CommerceCare<span class="sup">&reg;</span> with your provider.
        </h2>
        <p
          class="provider-statement-non-auth_form_description"
          v-if="selectedProvider.isHSF && selectedProvider.isFixedRate"
        >
          {{selectedProvider.providerName}} offers a {{ selectedProvider.fixedInterestRate}}% APR for HSF<span class="sup">&reg;</span>. Select enroll to be taken to your enrollment process.
        </p>
        <p
          class="provider-statement-non-auth_form_description"
          v-else-if="selectedProvider.isHSF && !selectedProvider.isFixedRate"
        >
          {{selectedProvider.providerName}} offers a {{selectedProvider.rateMargin}}% APR* for HSF<span class="sup">&reg;</span>. Select enroll to be taken to your enrollment process.
        </p>
        <p
          class="provider-statement-non-auth_form_description"
          v-else-if="selectedProvider.isCommerceCare"
        >
          Select apply to be taken to your application with {{selectedProvider.providerName}}. A credit check is required*
        </p>
        <div class="provider-statement-non-auth_actions vcore_row">
          <div
            class="provider-statement-non-auth_action_auth vcore_col--xs--12 vcore_col--sm--5 vcore_col--md--4 vcore_col--lg--3"
          >
            <Button
              v-if="selectedProvider.isHSF"
              id="provider-enrollment-btn_non-auth"
              size="large"
              color="blue"
              block
              @click.native="handleEnrollClick"
              >Enroll</Button
            >
            <Button
              v-else-if="selectedProvider.isCommerceCare"
              id="provider-enrollment-btn_non-auth"
              size="large"
              color="blue"
              block
              @click.native="handleApplyClick"
              >Apply</Button
            >
          </div>
        </div>
      </div>
    </section>
  </transition>
</template>

<script>
import Vue from "vue";
import Uuid from "@Shared/utils/Uuid";
import { mapGetters, mapActions } from "vuex";
import Button from "@Shared/components/Button";
import { EventBus } from "@Shared/utils/event-bus";

export default {
  name: "ProviderStatementNonAuth",
  components: {
    Button,
  },
  data() {
    return {
      id: "vertical-progress-flow-" + Uuid(),
      stepIndex: 2, // 0 count, must match component order in slot
    };
  },
  computed: {
    ...mapGetters(["enrollmentCurrentSearchStepIndex", "selectedProvider"]),

    isShown() {
      return this.stepIndex <= this.enrollmentCurrentSearchStepIndex;
    },
    console: () => console,
    renderDescriptionText() {
      if (this.selectedProvider.isHSF) {
        if (this.selectedProvider.isFixedRate) {
          return `${this.selectedProvider.providerName} offers a ${this.selectedProvider.fixedInterestRate}% APR for HSF®. Select enroll to be
          taken to your enrollment process.`;
        }
        else {
          return `${this.selectedProvider.providerName} offers a ${this.selectedProvider.rateMargin}% APR* for HSF®. Select enroll to be
          taken to your enrollment process.`;
        }
      } 
      else if (this.selectedProvider.isCommerceCare) {
        return `Select apply to be taken to your application with
                ${this.selectedProvider.providerName}. A credit check is required*.`;
      } 
      return ""
    }
  },
  watch: {
    isShown(val) {
      this.$nextTick(() => {
        this.updateOffsetTop();

        if (val) {
          this.$refs.sectionTitle.focus();
        }
      });
    },
  },
  methods: {
    ...mapActions(["incrementEnrollmentCurrentStepIndex"]),

    handleEnrollClick() {
      this.incrementEnrollmentCurrentStepIndex();

      this.$router.push({
        name: "enroll-forms",
        params: { step: "frp-information" },
      });
      this.$ga.event({
        eventCategory: "Provider Enrollment",
        eventAction: "Button Click",
        eventLabel: "Non-Auth",
      });
    },
    handleApplyClick() {
      this.incrementEnrollmentCurrentStepIndex();

      const guid = this.selectedProvider.enrollmentInstitutionId.slice(-9);

      this.$ga.event({
        eventCategory: "Provider Enrollment",
        eventAction: "Button Click",
        eventLabel: "Non-Auth",
      });

      window.location = `${process.env.VUE_APP_COMMERCE_CARE_PATH}?guid=` + guid;
    },
    updateOffsetTop() {
      Vue.set(
        this.verticalProgressSteps[this.stepIndex],
        "offsetTop",
        this.$refs["provider-statement-non-auth"].offsetTop
      );
    },
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      const { height } = getComputedStyle(element);
      element.style.height = this.prevHeight;
      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = "auto";
    },
  },
  inject: ["verticalProgressSteps"],
  mounted() {
    const elements = document.getElementsByClassName("provider-selection-item-grid");
    let lastElement = elements[0];
    this.verticalProgressSteps.push({
      id: this.id,
      stepIndex: this.stepIndex,
      offsetTop: lastElement.offsetTop + lastElement.offsetHeight + 400,
    });
    EventBus.$on("window-resize", this.updateOffsetTop);
    EventBus.$on("update-offset", this.updateOffsetTop);
  },
  destroyed() {
    EventBus.$off("window-resize", this.updateOffsetTop);
    EventBus.$off("update-offset", this.updateOffsetTop);
  },
};
</script>

<style lang="scss" scoped>
.provider-statement-non-auth {
  margin-top: 35px;

  .provider-statement-non-auth_form {
    background-color: $color_gray-7;
    padding: 60px 38px;
    border-radius: 10px;

    .sup {
      font-size: 70%;
      vertical-align: super;
    }

    .provider-statement-non-auth_form_title {
      font-size: 24px;
      font-weight: 600;
    }

    .provider-statement-non-auth_form_description {
      margin-top: 15px;
      line-height: 22px;
    }
  }

  .provider-statement-non-auth_actions {
    margin-top: 30px;
  }

  .provider-statement-non-auth_action_no-auth {
    font-size: 14px;
    font-weight: bold;
    color: $color_dark-blue;
    text-decoration: none;

    > div {
      padding: 4px;
    }
  }

  .provider-statement-non-auth_action_auth {
    @media (max-width: $grid-breakpoint-sm) {
      margin-top: 20px;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity;
  transition-timing-function: ease;
  overflow: hidden;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
